<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="isOpened">
  <div class="esf-container esf-container--full-width">
    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='Main heading for the customer search component@@customerSearchComponent.heading.customerSearch'
            class="esf-action-heading__text">Customer Search</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                  (click)="navigateToCreateCustomer()"
                  [edsTooltip]="tooltipTranslations.i18nCreateNewCustomer">
            <svg class="esf-icon" width="16" height="16">
              <use xlink:href="#esf-icon-user-add"></use>
            </svg>
          </button>
        </span>
      </span>
    </h1>

    <div class="esf-horizontal-tabs">
      <ul class="esf-horizontal-tabs__list">
        <li class="esf-horizontal-tabs__list-item" (click)="switchSearch(true)">
          <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="checkSearch('basic')"
                i18n='The tab title text for the basic search@@customerSearchComponent.tabTitle.basicSearch'>Basic search</span>
        </li>
        <li class="esf-horizontal-tabs__list-item" (click)="switchSearch(false)">
          <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="checkSearch('advanced')"
                i18n='The tab title text for the advanced search@@customerSearchComponent.tabTitle.advancedSearch'>Advanced search</span>
        </li>
      </ul>
    </div>

    <router-outlet></router-outlet>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="customers"
                         [initialLoad]="false"
                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (rowClickEvent)="rowClicked($event)"
                         (dataFetchedEmitter)="setCustomers($event)">
    </app-paginated-table>
  </div>

  <aside class="esf-main-content__sidebar">
    <div class="esf-container">
      <h3 i18n='Section heading for the recent searches part@@customerSearchComponent.subHeading.recentSearches'>Recent searches</h3>
      <ul class="esf-activities" *ngIf="searchHistory?.length">
        <li class="esf-activity" *ngFor="let search of searchHistory">
          <span [ngSwitch]="search.basic">
            <span *ngSwitchCase="true">
              <div class="esf-activity__text">
                <span i18n='Text inside section@@customerSearchComponent.text.searchedFor'>Searched for</span>
                <span>&nbsp;</span>
                <span class="esf-text--link clickable" (click)="searchFromHistory(search)">{{ search.values }}</span>
              </div>
              <div class="esf-activity__time">{{ search.date | date: 'dd.MM.yyyy HH:mm' }}</div>
            </span>
            <span *ngSwitchCase="false">
              <div class="esf-activity__text">
                <span i18n='Text inside section@@customerSearchComponent.text.searchedFor'>Searched for</span>
                <span>&nbsp;</span>
                <span class="esf-text--link clickable" (click)="searchFromHistory(search)">
                  <span *ngFor="let item of search.values | keyvalue">
                    <span style="overflow-wrap: break-word">{{ item.value }}</span>
                    <span>&nbsp;</span>
                  </span>
                </span>
              </div>
              <div class="esf-activity__time">{{ search.date | date: 'dd.MM.yyyy HH:mm' }}</div>
            </span>
          </span>
        </li>
      </ul>
    </div>
  </aside>
</main>
